import React, { Component } from 'react';
import './about.css';
import about from "../../../../../assets/about.svg";

export default class About extends Component {
    render() {
        return (
            <div>
                <div className="secondsec">
                    <div className="main-2">
                        <h1>Who We are?</h1>
                        <div className="about-p">
                            <div className="secondsec-imgcontainer">
                                <img src={about} alt="about image" />
                            </div>
                            <p>
                                <b>TheoryDev</b> is all about providing web development
                                services like Html, CSS, JavaScript, React, web design,
                                logo design, etc. to our customers who want their
                                entrepreneurship skills to reach the masses of this virtually
                                connected world. We wish to establish a stiff web base for our
                                customers and to provide them with the best of our potentials
                                at an affordable rate. We believe customer's satisfaction as
                                our main goal and so we try to give our full effort to fulfill
                                it.
                                </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
